/**
 * @generated SignedSource<<206f94d992d3c884d9a8bbb0408e016a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectInvoicingTableSection_company$data = {
  readonly newXeroEnabled: boolean | null;
  readonly quickbooksEnabled: boolean | null;
  readonly economicEnabled: boolean | null;
  readonly sageIntacctConnectionEnabled: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectInvoicingTable_company" | "ExportInvoiceButton_company" | "InvoiceFilterButton_company">;
  readonly " $fragmentType": "ProjectInvoicingTableSection_company";
};
export type ProjectInvoicingTableSection_company$key = {
  readonly " $data"?: ProjectInvoicingTableSection_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectInvoicingTableSection_company">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "xeroInvoicingImprovements",
    "variableName": "xeroInvoicingImprovements"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "xeroInvoicingImprovements"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectInvoicingTableSection_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "newXeroEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "quickbooksEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "economicEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sageIntacctConnectionEnabled",
      "storageKey": null
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "ProjectInvoicingTable_company"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "ExportInvoiceButton_company"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InvoiceFilterButton_company"
    }
  ],
  "type": "Company",
  "abstractKey": null
};
})();

(node as any).hash = "6695603dcb68a9361dc8ed4d01dadda8";

export default node;
